// The Purchase VIP Card page on vsga.org, where the offers and clubs pages send golfers to buy or renew.
export const PURCHASE_PAGE_URL = process.env.REACT_APP_PURCHASE_URL || "https://vsga.org/purchase-vip-card";

// Inside the MyVSGA app, purchasing happens in the device browser rather than the app's web view.
const isInMobileApp = () => navigator.userAgent.includes("org.vsga.myvsga");

// Purchase VIP Card: go to the purchase page (a new tab in the MyVSGA app).
export const goToPurchasePage = () => {
  if (isInMobileApp()) {
    window.open(PURCHASE_PAGE_URL, "_blank", "noopener,noreferrer");
    return;
  }
  window.location.href = PURCHASE_PAGE_URL;
};

// Renew: open the purchase page in a new tab, leaving the offers page open.
export const openPurchasePageInNewTab = () => {
  window.open(PURCHASE_PAGE_URL, "_blank", "noopener,noreferrer");
};
